// Head-to-head duels — a thin, pure lens over the existing round scoring. A duel
// NEVER introduces a new market, weighting, or "decider" mechanic: it just decides
// who scored more across the round with the standard confidence-weighted engine.
// (The UI may label a player's highest-confidence pick a "decider"; that is purely
// presentational and changes no points — see the project rules.)
import { scoreEntry } from './scoring.js';
/**
 * Decide a duel from two already-computed round scores. Higher score wins; an
 * exact tie is a draw (no tiebreak — a duel is a friendly mirror of the round).
 */
export function decideDuel(duel, challengerScore, opponentScore) {
    let winnerId = null;
    if (challengerScore > opponentScore)
        winnerId = duel.challengerId;
    else if (opponentScore > challengerScore)
        winnerId = duel.opponentId;
    return { challengerScore, opponentScore, winnerId };
}
/**
 * Decide a duel directly from both players' entries against the same settled
 * results. Either entry may be missing (never submitted) → that side scores 0.
 */
export function resolveDuelFromEntries(duel, challengerEntry, opponentEntry, results) {
    const cs = challengerEntry ? scoreEntry(challengerEntry, results).roundScore : 0;
    const os = opponentEntry ? scoreEntry(opponentEntry, results).roundScore : 0;
    return decideDuel(duel, cs, os);
}
/** Generate a short uppercase invite/join code from the allowed alphabet. */
export function generateInviteCode(length, rng = Math.random) {
    // No ambiguous characters (no 0/O/1/I) so codes are easy to read aloud.
    const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let out = '';
    for (let i = 0; i < length; i++)
        out += alphabet[Math.floor(rng() * alphabet.length)];
    return out;
}
/** Strip any formatting (dashes/spaces) and uppercase an entered invite code. */
export function normalizeInviteCode(raw) {
    return raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
}
/** Present an invite code with a readability dash at the midpoint, e.g. "4F9-K2P". */
export function formatInviteCode(code) {
    const c = normalizeInviteCode(code);
    if (c.length <= 3)
        return c;
    const mid = Math.ceil(c.length / 2);
    return `${c.slice(0, mid)}-${c.slice(mid)}`;
}
//# sourceMappingURL=duels.js.map